import { FC } from "react";

export const Logo: FC = () => (
  <svg
    width="208"
    height="80"
    viewBox="0 0 208 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    
  </svg>
);
